<template>
    <div>
        <b-button class="w-100 mb-1"
                  @click="disableNotifications" variant="outline-secondary">
            <i class="fa-solid fa-envelope"></i>
            {{ $t('action-items.notifications-disable') }}
        </b-button>
        <b-button class="w-100 mb-1"
                  @click="enableNotifications" variant="outline-secondary">
            <i class="fa-solid fa-envelope"></i>
            {{ $t('action-items.notifications-enable') }}
        </b-button>
    </div>
</template>

<script>
import {useToast} from "vue-toastification";

export default {
    name: "Notifications",
    props: [
        'uuids'
    ],
    methods: {
        enableNotifications(){
            let externalCommands = [];
            if(this.uuids.length > 0){
                for(var i = 0; i < this.uuids.length; i++){
                    externalCommands.push({
                        serviceUuid: this.uuids[i].serviceUuid,
                        hostUuid: this.uuids[i].hostUuid,
                        command: 'submitEnableServiceNotifications',

                    });
                }
                this.$emit('masscommand', externalCommands);
            }else{
                useToast().error('no services selected', {
                    timeout: 2000
                });
            }
        },
        disableNotifications(){
            let externalCommands = [];
            if(this.uuids.length > 0){
                for(var i = 0; i < this.uuids.length; i++){
                    externalCommands.push({
                        serviceUuid: this.uuids[i].serviceUuid,
                        hostUuid: this.uuids[i].hostUuid,
                        command: 'submitDisableServiceNotifications',
                    });
                }
                this.$emit('masscommand', externalCommands);
            }else {
                useToast().error('no services selected', {
                    timeout: 2000
                });
            }
        }
    }
}
</script>

<style scoped>

</style>
